// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IReT","expireSoon":"styles_expireSoon__1YJce"};